export default __webpack_public_path__ + "static/media/atm.a9e9c229.svg";